import { render, staticRenderFns } from "./TouchControls.vue?vue&type=template&id=36f6e1df&"
import script from "./TouchControls.vue?vue&type=script&lang=js&"
export * from "./TouchControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports